const styles = {
  QUEUED: { bg: "bg-canvas-border", text: "text-espresso-ink", label: "Queued" },
  PROCESSING: { bg: "bg-gold-soft", text: "text-gold", label: "Processing" },
  DRAFT_IN_DOCHUB: { bg: "bg-[#E65100]/10", text: "text-status-pending", label: "Draft" },
  PUBLISHED: { bg: "bg-[#2E7D32]/10", text: "text-status-synced", label: "Published" },
  DUPLICATE_SUSPECT: { bg: "bg-[#C62828]/10", text: "text-status-duplicate", label: "Duplicate Suspect" },
  UNASSIGNED: { bg: "bg-gold-soft", text: "text-espresso", label: "Unassigned" },
  ERROR: { bg: "bg-[#C62828]/10", text: "text-status-duplicate", label: "Error" },
};

export default function StatusBadge({ status, className = "" }) {
  const s = styles[status] || { bg: "bg-canvas-border", text: "text-espresso-ink", label: status };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider ${s.bg} ${s.text} ${className}`}
    >
      {s.label}
    </span>
  );
}
